import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';

const AddVideo = () => {
  const [formData, setFormData] = useState({
    title: '',
    url: '',
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await postRequest('videos', formData);

      if (response?.status === 200 || response?.status === 201) {
        toast.success('Video added successfully!');
        navigate('/gallery/video');
        setFormData({ title: '', url: '' });
      } else {
        toast.error('Something went wrong!');
      }
    } catch (error) {
      console.error('Error adding video:', error);
      toast.error('Failed to add video. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add YouTube Video</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row mx-4">
          <div className="col-sm-12 mt-2">
            <label htmlFor="videoTitle" className="adminlables">Video Title *</label>
            <input
              type="text"
              id="videoTitle"
              name="title"
              value={formData.title}
              className="form-control"
              onChange={handleChange}
              placeholder="e.g. PRERNA Incubation Program tour"
              required
            />
          </div>
          <div className="col-sm-12 mt-4">
            <label htmlFor="videoUrl" className="adminlables">YouTube URL *</label>
            <input
              type="url"
              id="videoUrl"
              name="url"
              value={formData.url}
              className="form-control"
              onChange={handleChange}
              placeholder="e.g. https://www.youtube.com/watch?v=dQw4w9WgXcQ"
              required
            />
          </div>
        </div>
        <div className="mt-4 text-right mx-5">
          <button className="btn addbtn btn-lg" type="submit" disabled={loading}>
            {loading ? 'Adding...' : 'Add Video'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddVideo;
